<!-- 공통 파일 첨부 컴포넌트 (eony, 2022/06/09) -->
<template>
  <v-row class="ma-0">
    <v-col cols="12" class="pt-5 pb-8 px-6 bt-line bb-line">
      <div class="borderLine-wrap" @click="clickFileInput()">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          :ripple="false"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
        <input
          v-show="false"
          type="file"
          ref="fileInput"
          accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.jpeg,.jpg,.png,.bmp,.gif,.txt"
          @change="fileSelect($event)"
        />
      </div>
      <div class="pt-3 pb-0">
        <span v-if="getFileList.length === 0" class="place-holder"
          >파일 첨부하기</span
        >
        <v-list flat class="add-box-list">
          <v-list-item-group>
            <v-list-item v-for="(file, i) in getFileList" :key="i" class="px-4">
              <v-list-item-content @click="downloadFile(file)">
                <v-list-item-title>
                  <file-img-icon v-bind:fileType="getFileType(file)" />
                  <span v-text="file.filename"></span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon @click="removeFile(file, i)">
                <v-icon>mdi-close</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </v-col>
  </v-row>
</template>

<script>
/* 첨부파일 추가 컴포넌트 */
import FileImgIcon from '@/components/common/FileImgIcon.vue';
import { callApp } from '@/utils/app/callApp.js';
import { upload, downloadFile, deleteFile } from '@/api/file';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    fileList: [],
  }),

  computed: {
    ...mapGetters('ELA', ['GET_FILE_ID', 'GET_FILE_LIST']),

    getFileList: {
      get() {
        // console.log(this.GET_FILE_LIST);
        return this.GET_FILE_LIST;
      },
      set(data) {
        this.SET_FILE_LIST(data);
      },
    },
  },

  methods: {
    ...mapMutations('ELA', ['SET_FILE_ID', 'SET_FILE_LIST']),
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    /* 파일 업로드 */
    async fileUpload(file) {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('uploadType', 'ela');
      formData.append('fileId', this.GET_FILE_ID);
      formData.append('gubun1', '@yyyyMM@');
      formData.append('gubun2', '');

      try {
        const { data } = await upload(formData);
        if (data.message === 'OK') {
          this.fileList.push(data.fileList[0]);
          this.SET_FILE_ID(data.fileList[0].saveFileId);
          this.SET_FILE_LIST(this.fileList);
          this.OFF_APP_SPINNER(); // 스피너 OFF
        } else {
          alert(data.message);
        }
      } catch (error) {
        alert(error);
      }
    },

    /* 파일 다운로드 */
    async downloadFile(file) {
      try {
        const response = await downloadFile({
          fileName: file.filename,
          fileId: file.saveFileId,
          seqNo: file.seqNo,
        });
        const fileData = response.data;
        callApp.downloadFile({ dataUrl: fileData, fileName: file.filename });
      } catch (error) {
        alert(error);
      }
    },

    /* 파일 삭제 */
    async removeFile(file, i) {
      const formData = new FormData();
      formData.append('seqNo', file.seqNo);
      formData.append('fileId', file.saveFileId);

      try {
        const { data } = await deleteFile(formData);
        if (data.message === 'OK') {
          this.fileList.splice(i, 1);
          this.SET_FILE_LIST(this.fileList);
        } else {
          alert(data.message);
        }
      } catch (error) {
        alert(error);
      }
    },

    clickFileInput() {
      this.$refs['fileInput'].click();
    },

    fileSelect(e) {
      this.ON_APP_SPINNER(); // 스피너 ON
      const file = e.target.files[0];
      this.fileUpload(file);
      this.$refs['fileInput'].value = null;
    },

    getFileType(file) {
      const fileName = file.filename.split('.');
      return fileName[fileName.length - 1];
    },
  },

  components: {
    FileImgIcon,
  },
};
</script>

<style></style>
